module.exports = __webpack_public_path__ + "static/media/gcourse4.0362d6c5.png";